var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVacuum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "40px",
    height: "40px",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    fill: "#1E81F7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M31,28h-3v-5.3c0-6.5-2.2-12.8-6.3-17.9C21,4,20.1,3.4,19,3.3c-1.1-0.1-2.2,0.2-3,0.9C15,4.9,14.5,5.9,14.4,7 c-0.1,1.1,0.3,2.2,1,3.1l1.1,1.3c1.6,1.8,1.6,4.5,0.2,6.4l-1.3-1.3c-1-1-2.4-1.5-3.9-1.5H8.1c-2.7,0-5,1.9-5.5,4.4 C3.4,19.1,4.2,19,5,19c3.9,0,7,3.1,7,7c0,1.5-0.5,2.9-1.3,4h4.3c2.5,0,4.6-1.4,5.5-3.7c0.9-2.1,0.3-4.5-1.4-6.1l-1.1-1 c2.2-2.6,2.2-6.5-0.1-9.1l-1.1-1.3c-0.4-0.4-0.6-1-0.5-1.6c0.1-0.6,0.3-1.1,0.8-1.5c0.4-0.4,1-0.5,1.6-0.5c0.6,0.1,1.1,0.3,1.4,0.8 c3.8,4.7,5.8,10.6,5.8,16.6V28h-1c-0.6,0-1,0.4-1,1s0.4,1,1,1h6c0.6,0,1-0.4,1-1S31.6,28,31,28z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 26,
    r: 5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVacuum);
export default __webpack_public_path__ + "static/media/vacuum.5ca169c98b893065b92078b622d37929.svg";
export { ForwardRef as ReactComponent };